<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="astral-content-width astral-stack-l">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']"></astral-input>
          <astral-select [control]="form.controls['meterType']" [itemsSource]="meterTypeSelection"></astral-select>
          @if (currencySelection && currencySelection.length > 1) {
            <astral-select [control]="form.controls['currencyCode']" [itemsSource]="currencySelection"></astral-select>
          }
          <astral-select [control]="form.controls['articleId']" [itemsSource]="articleSelection"></astral-select>
        </astral-layout-group>
      </section>

      @for (priceForm of $any(prices.controls); track priceForm; let i = $index) {
        <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            <astral-date-picker [control]="priceForm.controls['fromDate']"></astral-date-picker>
            <app-money-box [control]="priceForm.controls['amountPerUnit']"></app-money-box>
            <div class="astral-form-adjacent-action">
              <astral-button variant="secondary" icon="trash" labelKey="DELETE_BTN" type="button" (click)="removePrice(i)"></astral-button>
            </div>
          </astral-layout-group>
        </section>
      }

      <div class="astral-form-actions">
        <astral-button variant="primary" icon="plus" labelKey="CREATE_BTN" type="button" (click)="addPrice()"></astral-button>
      </div>
    </form>
  }
</section>
